import { defHttp } from '/@/utils/http/axios'
import type { getMenuListResultModel } from './model/menuModel'

enum Api {
    GetMenuList = '/user/getMenuList',
}

/**
 * @description: Get user menu based on id
 */

export function getMenuList() {
    return defHttp.get<getMenuListResultModel>({ url: Api.GetMenuList })
}
